import { t } from '@lingui/macro';

export const COLUMNS = {
  customIdentifier: { key: 'customIdentifier', label: t`ID` },
  description: { key: 'description', label: t`Description` },
  owner: { key: 'owner', label: t`Owner` },
  status: { key: 'status', label: t`Status` },
  title: { key: 'title', label: t`Title` },
};
